import infoBoard from '../infoboard';

const tour = () =>
    [{
        element: '#trigger-infoboard',
        title: 'Quadro de Informações',
        content: 'Clique neste botão para acessar o quadro de informações do NeoGIG.',
        placement: 'left',
        onShow () {
            return infoBoard.close();
        },
        onHide () {
            return infoBoard.close();
        }
    }];

export default tour;



// WEBPACK FOOTER //
// ./src/scripts/core/tour/infoboard.js